































import Vue from 'vue'
import LeftSidebar from '@/components/LeftSidebar'
import { AbilityAction, AbilitySubject } from '@/abilitiesByRole'
import './LeftSidebarLayout.scss'
import { Feature } from '@/featureFlags/featureFlags'

interface LeftMenuItem {
  label: string
  pathName: string
  allow: AbilitySubject
}

export default Vue.extend({
  name: 'LeftSidebarLayout',
  props: {
    title: {
      type: String,
      required: false,
      default: ''
    },
    hasBottom: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    teamCheck (): boolean | null {
      return this.$store.direct.state.user.teamCheck
    },
    items (): LeftMenuItem[] {
      const availableItems: LeftMenuItem[] = []
      if (!this.$store.direct.state.team.teamLoaded) return availableItems
      availableItems.push({ label: 'Events', pathName: 'events', allow: AbilitySubject.Event })
      availableItems.push({ label: 'Streams', pathName: 'streams', allow: AbilitySubject.Stream })
      availableItems.push({ label: 'Assets', pathName: 'assets', allow: AbilitySubject.AssetGroups })
      availableItems.push({ label: 'Members', pathName: 'team', allow: AbilitySubject.Members })
      availableItems.push({ label: 'Scene Layouts', pathName: 'layout', allow: AbilitySubject.Layout })
      availableItems.push({ label: 'Event Templates', pathName: 'castTemplates', allow: AbilitySubject.CastTemplates })
      availableItems.push({ label: 'Reports', pathName: 'reports', allow: AbilitySubject.Report })
      availableItems.push({ label: 'Team Settings', pathName: 'teamsettings', allow: AbilitySubject.TeamSettings })
      if (this.$hasFeature(Feature.SELF_SERVE)) {
        availableItems.push({ label: 'Support', pathName: 'selfServeSupport', allow: AbilitySubject.Event })
      }
      return availableItems
    },
    allowedItems (): LeftMenuItem[] {
      const items: LeftMenuItem[] = []
      this.items.forEach(item => {
        if (!item.allow || this.$can(AbilityAction.Read, item.allow)) {
          items.push({...item })
        }
      })
      return items
    },
    fullscreen (): boolean {
      return this.allowedItems.length <= 1
    }
  },
  watch: {
    allowedItems (newVal: LeftMenuItem[]): void {
      if (newVal.length === 0) {
        this.$store.direct.dispatch.user.updateDefaultPageOnLogin(null)
        return
      }
      this.$store.direct.dispatch.user.updateDefaultPageOnLogin(newVal[0].pathName)
    }
  },
  data: () => ({
    adminMenuItems: [
      {
        label: 'Teams',
        pathName: 'teams'
      },
      {
        label: 'Operations',
        pathName: 'ops',
        children: [
          { label: 'Overview', pathName: 'ops' },
          { label: 'WRTC Servers', pathName: 'opswrtcservers' },
          { label: 'Transcoding Machines', pathName: 'opstranscoding' },
          { label: 'SRT Overview', pathName: 'Ops SRT' },
          { label: 'Archiver Overview', pathName: 'opsarchiver' },
          { label: 'Backend', pathName: 'ops_backendservices' }
        ]
      }
    ]
  }),
  components: {
    LeftSidebar
  }
})
